export const fontSizes = {
  xs: "14px",
  sm: "14px",
  md: "14px",
  lg: "14px",
  xl: "14px",
}